import React from "react";
import PropTypes from "prop-types";

import "./LoginInput.css";

export default class LoginInput extends React.Component {
  render() {
    return (
      <div className="loginInputContainer">
        <input
          className="loginInput"
          type={this.props.type}
          autoComplete={this.props.autoComplete}
          placeholder={this.props.placeholder}
          onChange={this.props.onChange}
          value={this.props.value}
        />
      </div>
    );
  }
}

LoginInput.propTypes = {
  placeholder: PropTypes.string,
  autoComplete: PropTypes.string,
  type: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string
};
